export default __webpack_public_path__ + "static/media/1149.98c853d9.png";